import Endpoints from '@/config/ApiEndpoints.js';
import Axios from 'axios';
import LicenceCategories from "@/assets/json_data/licence_categories.json";
import { required, email, minLength, sameAs } from 'vuelidate/lib/validators';
import DriverAdditionalFields from "@/assets/js/const.js";
import $ from "jquery";

export default {
	components:{

	},
	data() {
		return {
			ShowLoader: false,
			Saving: false,
			submitted: false,
			FileLoader: false,
			hgvModule: false,
			file: '',
			Categories:LicenceCategories,
			LicenceCatInfo:"",
			DriverAdditionalFieldData:"",
			Vehicles:[],
			Vehicle:[],
			Branches:{},
			NewDriver: {
				branch_id:0,
				accidents:0,
				vehicle_id: '',
				forename: '',
				surname: '',
				phone: '',
				email: '',
				address: '',
				post_code: '',
				dob: '',
				ni_number: '',
				next_of_kin: '',
				ice_contact: '',
				image: '',

				company_name: '',
				company_start_date: '',
        		company_driver_id: '',
				company_position: '',
				company_phone: '',
				company_email: '',
				company_driver_type: 'Company',
				account_type: 1,

				license_category: [],
				license_expiry: '',
				license_number: '',
        		license_codes: '',
				license_check_date:'',
				penality_points: '',
				notes: '',
				is_dvla_notifiable:false,
				dvla_notified:false,
				referred_to_doctor:false,
				is_dvla_driving:false,
				eyesight_health:false,
				receive_email:false,
			},
			FleetSubscription:[],
			select_branch:true,
			FleetSubscriptionModules:[]     
		}
	},
	validations: {
	    NewDriver: {
			forename: { required },
			surname: { required },
			//phone: { required,minLength: minLength(10)  },
			email: { required,email },
			//dob: { required },
			//ni_number: { required },
			//next_of_kin: { required },
			//ice_contact: { required },
			//license_category: { required },
			//license_expiry: { required },
			//license_number: { required },
	    },
  	},
	mounted() {
		//check account permission
		var AccountPermissions = JSON.parse(
			localStorage.getItem("AccountPermissions")
		  );
		  this.FleetSubscription = JSON.parse(
			localStorage.getItem("FleetSubscription")
		  );
		  var FleetSubscriptionModules = JSON.parse(
			this.FleetSubscription.fleet_modules
		  );
		  this.FleetSubscriptionModules = FleetSubscriptionModules;
		if(FleetSubscriptionModules["Hierarchy System"] && (!AccountPermissions.Driver || !AccountPermissions.Driver.enable || !AccountPermissions.Driver.add) ){
			this.$router.push('/');
		}
		this.DriverAdditionalFieldData = DriverAdditionalFields();
		document.title = pbx_SiteTitle+' - Driver Add';
		let CompanyData = JSON.parse(localStorage.getItem('Company'));
		this.NewDriver.company_name = CompanyData.name;
		this.GetCompanySubscription();
		this.GetVehiclesListForAssign();
		this.GetBranches();


	},

	methods : {
		GetBranches(){
			var obj = { token: localStorage.getItem("token"), select_branch: true };
			Axios.post(Endpoints.Branch.List, obj).then((Response) => {
				if (Response?.data?.success) {
					this.Branches = Response.data.records;
					if(this.FleetSubscriptionModules["Hierarchy System"] && this.Branches.length == 1){
						this.NewDriver.branch_id = this.Branches[0].id;
						this.select_branch = false;
					}
				}
			});
		},
		loadText(selectObject){
			var text = $('.lic_category option:selected').attr('description');
			this.LicenceCatInfo = text;
		},
		SetDriverType(type){
			this.NewDriver.company_driver_type=type
		},
		SetDriverAccountType(type){
			this.NewDriver.account_type=type
		},
		SetDVLAMedicalConditions(type){
			this.NewDriver.is_dvla_notifiable = type;
		},
		SetDVLANotified(type){
			this.NewDriver.dvla_notified = type;
		},
		SetReferredToDoctor(type){
			this.NewDriver.referred_to_doctor = type;
		},
		SetContinueDriving(type){
			this.NewDriver.is_dvla_driving = type;
		},
		SetEyesight(type){
			this.NewDriver.eyesight_health = type;
		},
		SetReceiveEmail(type){
			this.NewDriver.receive_email = type;
		},
		GetVehiclesListForAssign(){
			var obj={token: localStorage.getItem('token')}
			Axios.post(Endpoints.Vehicle.ListForAssign, obj).then((Response) => {
				if (Response?.data?.success) {
					this.Vehicles = Response.data.vehicles
				}
			})
		},
		onVehicleSelect(evt){
			if(this.NewDriver.vehicle_id > 0){
				/* this.Vehicles.forEach(element=>{
					if(element.id == this.NewDriver.vehicle_id){
						this.Vehicle = element
					}
				}) */
				this.GetVehicleDetail(this.NewDriver.vehicle_id);
			}else{
				this.Vehicle.mot_due = '';
				this.Vehicle.tax_due = '';
				this.Vehicle.insurance_expiry = '';
				this.Vehicle.current_mileage = '';
				this.Vehicle.lastservice_mile = '';
				this.Vehicle.lastservice_date = '';
				this.Vehicle.nextservice_date = '';
			}
		},
		GetVehicleDetail(vehicle_id) {
			Axios.post(Endpoints.Vehicle.Get, {
			  token: localStorage.getItem("token"),
			  vehicle_id: vehicle_id,
			}).then((Response) => {
			  if (Response?.data?.success) {
				this.Vehicle = Response.data.vehicle;
			  }
			});
		  },
		handleFileUpload() {
      		this.file = this.$refs.file.files[0];
    	},
		CreateDriverData() {
			this.submitted = true;
	      	this.$v.$touch();
	      	//console.log(this.NewDriver);
	      	if (this.$v.$invalid) {
	        	return;
	      	}
	      	this.Saving = true;
			let formData = new FormData();
			if (this.$refs.file && this.$refs.file.files[0]) {
			formData.append('token', localStorage.getItem('token'));
			formData.append('storage_type', 'CFDR');
			formData.append('file', this.file);
			Axios.post(Endpoints.File.Upload, formData).then((Response) => {
				this.Saving = false;
				if (Response?.data?.success == true) {
				  	this.NewDriver.image = Response.data.file;
				  	this.CreateDriver();
				} else {
					this.$swal.fire('Error in File Uploading', '', 'error').then(() => {});
				}
			});
		}else{
			this.CreateDriver();
		}
    	},
		GetCompanySubscription(){
			var FleetSubscriptionModules = JSON.parse(
				JSON.parse(localStorage.getItem("FleetSubscription")).fleet_modules
			  );
			  const isHGV = FleetSubscriptionModules.HGV;
			  if(isHGV){
				this.hgvModule = true;
			}
			
		},
		CreateDriver() {
	      	Axios.post(Endpoints.Driver.Create, {token: localStorage.getItem('token'),...this.NewDriver}).then((Response) => {
	        	this.Saving = false;
	        	if (Response?.data?.success) {
					this.$swal.fire('Driver Added Successfully', '', 'success').then(() => {
	            		this.$router.push('/drivers-list');
	          		});
	        	} else {
					this.$swal.fire({
	            		title: 'Oops!',
	            		text: Response?.data?.message || "Something went wrong",
	            		icon: 'error',
	            		confirmButtonText: 'Close',
	          		});
        		}
	      	});
    	},

	}
}
